import React, { useState, useEffect } from "react";
import {
  FaFilter,
  FaSearch,
  FaChevronRight,
  FaPlus,
  FaStethoscope,
  FaPaperPlane,
  FaUsers,
} from "react-icons/fa";
import { FaUserDoctor } from "react-icons/fa6";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import { Link } from "react-router-dom";
import { getClinicalSites, getClinicalSiteStats } from "../../services/clinical_sites";
import {
  getAgeRange,
  getClinicalSite,
  getClinicalSiteCities,
  getClinicalSiteCountries,
  getClinicalSiteType,
  getLocations,
  getStatus,
} from "../../utils/data";
import Footer from "../../components/footer";
import NewClinicalSite from "../../components/Admin/NewClinicalSite";
import { useUserProfile } from "../../hooks/getUserProfile";

const AdminDashboard = () => {
  const [clinicalSite, setclinicalSite] = useState(null);
  const [locations, setLocations] = useState(null);
  const [ageRange, setAgeRange] = useState(null);
  const [status, setStatus] = useState(null);
  const [clinicalSiteIcon, setClinicalSiteIcon] = useState(false);
  const [locationsIcon, setLocationsIcon] = useState(false);
  const [ageRangeIcon, setAgeRangeIcon] = useState(false);
  const [statusIcon, setStatusIcon] = useState(false);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const clinicalIconRotate = clinicalSiteIcon ? "rotate(180deg)" : "rotate(0)";
  const locationsIconRotate = locationsIcon ? "rotate(180deg)" : "rotate(0)";
  const ageRangeIconRotate = ageRangeIcon ? "rotate(180deg)" : "rotate(0)";
  const statusIconRotate = statusIcon ? "rotate(180deg)" : "rotate(0)";
  const handleClinical = (selected) => {
    setclinicalSite(selected);
  };

  const handleLocations = (selected) => {
    setLocations(selected);
  };

  const handleAge = (selected) => {
    setAgeRange(selected);
  };

  const handleStatus = (selected) => {
    setStatus(selected);
  };

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        // Get clinical site ID - using 1 as default based on your API example
        const clinicalSiteId = 1;
        const response = await getClinicalSiteStats(clinicalSiteId);

        if (response.status === 200) {
          setStats(response.data);
        } else {
          setError("Failed to fetch stats");
        }
      } catch (err) {
        setError("Error fetching dashboard stats");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);
  const {data} = useUserProfile()

  return (
    <>
      <div className="container-fluid pt-12 pl-21 pb-12 pr-24 h-100">
        {/* <div className="card border-0 h-100">
          <div className="card-body">
            <div className="d-flex justify-content-between">
              <h5 className="font-weight-lighter fs-18">
                Admin: Manage Clinical Sites & Positions
              </h5>
              <button
                className="btn btn-primary small-text d-flex align-items-center"
                data-toggle="modal"
                data-target="#newClinicalSite"
              >
                <FaPlus size={13} className="mr-2" />
                Create New Clinical Site
              </button>
              <NewClinicalSite />
            </div>
            <hr />
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <h5 className="font-weight-lighter mt-2 fs-18">
                  Master Clinical Sites List
                </h5>
                <h6 className="font-weight-lighter mt-2 fs-15">
                  Healthcare Organization
                </h6>
              </div>
              <div className="d-flex align-items-center" style={{ width: 355 }}>
                <div className="input-group bg_muted rounded">
                  <div className="input-group-prepend">
                    <span
                      className="input-group-text border-0 bg-transparent text-muted pr-3"
                      id="basic-addon1"
                    >
                      <FaSearch size={16} color="#c2c2c2" />
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control border-none bg_muted f-13 text-black outline-none rounded mr-3"
                    placeholder="Search"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <button
                  className="btn btn-outline-primary w-50 ml-3 rounded py-1"
                  data-toggle="modal"
                  data-target="#filterModal"
                >
                  <FaFilter size={16} />
                  &nbsp;&nbsp; <small>Filter</small>
                </button>
              </div>
            </div>
            <table className="table table-striped table-bordered mt-3 text-center">
              <thead className="head_light text-white">
                <tr className="f-11">
                  <th scope="col">Clinical Site Name</th>
                  <th scope="col">Clinical Site Type</th>
                  <th scope="col">Address</th>
                  <th scope="col">Phone Number</th>
                  <th scope="col">Date Created</th>
                  <th scope="col">HCP</th>
                  <th scope="col">Patients</th>
                  <th scope="col">Go to Clinical Site Page</th>
                </tr>
              </thead>
              <tbody>
                {getClinicalSites().map((item, i) => (
                  <tr key={i}>
                    <th>
                      <small>{item.clinicalSiteName}</small>
                    </th>
                    <td>
                      <small>{item.clinicalSiteType}</small>
                    </td>
                    <td>
                      <small>
                        {item.streetAddress} {item.city} {item.suite}{" "}
                        {item.country}
                      </small>
                    </td>
                    <td>
                      <small>{item.phoneNumber}</small>
                    </td>
                    <td>
                      <small>{item.createdAt}</small>
                    </td>
                    <td>
                      <small>{item.hcp}</small>
                    </td>
                    <td>
                      <small>{item.patients}</small>
                    </td>
                    <td>
                      <Link
                        to={`/admin/clinical_site/details/${item.id}`}
                        onClick={() =>
                          localStorage.setItem("clinical_site", item.id)
                        }
                        className="border_success rounded px-4"
                      >
                        <i className="fa fa-chevron-right" />
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div> */}
        <div className="mt-3 mb-5">
          <h5 className="font-weight-lighter fs-18 mb-3">ADMIN Dashboard</h5>
          <h5 className="font-weight-lighter mt-2 fs-18">
            Welcome back, {data?.data?.firstName || ""}
          </h5>
        </div>
        {error ? (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        ) : (
          <div className="d-flex justify-cntent-between">
            <div className="card card-body rounded-15 pl-4 py-4">
              {loading ? (
                <>
                  <div className="bg-light rounded" style={{ width: 50, height: 50 }}></div>
                  <div className="bg-light rounded my-4" style={{ width: 80, height: 16 }}></div>
                  <div className="bg-light rounded" style={{ width: 40, height: 24 }}></div>
                </>
              ) : (
                <>
                  <FaStethoscope size={50} className="text_success" />
                  <span className="text_small my-4">Patients</span>
                  <span className="font-weight-bold fs-18">
                    {stats?.patients || 0}
                  </span>
                </>
              )}
            </div>
            <div className="card card-body rounded-15 pl-4 py-4 ml-5">
              {loading ? (
                <>
                  <div className="bg-light rounded" style={{ width: 50, height: 50 }}></div>
                  <div className="bg-light rounded my-4" style={{ width: 120, height: 16 }}></div>
                  <div className="bg-light rounded" style={{ width: 40, height: 24 }}></div>
                </>
              ) : (
                <>
                  <FaPaperPlane size={50} className="text_success" />
                  <span className="text_small my-4">Clinical Locations</span>
                  <span className="font-weight-bold fs-18">
                    {stats?.clinicalLocations || 0}
                  </span>
                </>
              )}
            </div>
            <div className="card card-body rounded-15 pl-4 py-4 ml-5">
              {loading ? (
                <>
                  <div className="bg-light rounded" style={{ width: 50, height: 50 }}></div>
                  <div className="bg-light rounded my-4" style={{ width: 80, height: 16 }}></div>
                  <div className="bg-light rounded" style={{ width: 40, height: 24 }}></div>
                </>
              ) : (
                <>
                  <FaUserDoctor size={50} className="text_success" />
                  <span className="text_small my-4">Positions</span>
                  <span className="font-weight-bold fs-18">
                    {stats?.positions || 0}
                  </span>
                </>
              )}
            </div>
            <div className="card card-body rounded-15 pl-4 py-4 ml-5">
              {loading ? (
                <>
                  <div className="bg-light rounded" style={{ width: 50, height: 50 }}></div>
                  <div className="bg-light rounded my-4" style={{ width: 80, height: 16 }}></div>
                  <div className="bg-light rounded" style={{ width: 40, height: 24 }}></div>
                </>
              ) : (
                <>
                  <FaUsers size={50} className="text_success" />
                  <span className="text_small my-4">Users</span>
                  <span className="font-weight-bold fs-18">
                    {stats?.users || 0}
                  </span>
                </>
              )}
            </div>
          </div>
        )}
      </div>
      {/* <div
        className="modal fade"
        id="filterModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" style={{ width: "395px" }}>
          <div
            className="modal-content pt-3 border-0"
            style={{ borderRadius: "10px" }}
          >
            <div className="modal-header border-0">
              <div className="flex-grow-1 text-center">
                <h5 className="text_primary" style={{ fontWeight: 700 }}>
                  Search Filter
                </h5>
              </div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span
                  className="text_primary"
                  style={{ fontSize: 33, fontWeight: "600" }}
                  aria-hidden="true"
                >
                  &times;
                </span>
              </button>
            </div>
            <div className="modal-body px-3">
              <div className="mb-4">
                <input
                  type="text"
                  placeholder="Enter Clinical Site Name"
                  className="border-default rounded-sm overlay-dropdown-input small-text pl-12"
                />
              </div>
              <div className="dropdown mb-4">
                <div className="dropdown">
                  <button
                    className="btn btn-block border text-left overlay-dropdown-input"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    data-display="static"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClickCapture={() =>
                      setClinicalSiteIcon(!clinicalSiteIcon)
                    }
                  >
                    <div className="d-flex justify-content-between">
                      <small className="small-text">
                        Choose Clinical Site Type
                      </small>
                      <BsChevronDown
                        style={{
                          transform: clinicalIconRotate,
                          transition: "all 0.3s linear",
                        }}
                      />
                    </div>
                  </button>
                  <div
                    className="dropdown-menu dropdown-menu--animate custom border-0 shadow overlay-dropdown-container"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <p className="pl-2 mb-0 pb-2">
                      <small className="small-text">
                        Choose as many as applicable:
                      </small>
                    </p>
                    {getClinicalSiteType.map((item, key) => (
                      <div
                        className="dropdown-item noFilterHover form-group mb-0 form-check ml-4 wa nohover h-38"
                        key={key}
                      >
                        <input
                          type="checkbox"
                          className="form-check-input mt-2"
                          id="exampleCheck1"
                          onChange={() => handleClinical(item.value)}
                        />
                        <label className="form-check-label" for="exampleCheck1">
                          <small className="small-text">{item.label}</small>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="dropdown mb-4">
                <div className="dropdown">
                  <button
                    className="btn btn-block border text-left overlay-dropdown-input"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    data-display="static"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClickCapture={() => setLocationsIcon(!locationsIcon)}
                  >
                    <div className="d-flex justify-content-between">
                      <small className="small-text">Choose City</small>
                      <BsChevronDown
                        style={{
                          transform: locationsIconRotate,
                          transition: "all 0.3s linear",
                        }}
                      />
                    </div>
                  </button>
                  <div
                    className="dropdown-menu dropdown-menu--animate custom border-0 shadow overlay-dropdown-container"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <p className="pl-2 mb-0 pb-2">
                      <small className="small-text">
                        Choose as many as applicable:
                      </small>
                    </p>
                    {getClinicalSiteCities.map((item, key) => (
                      <div
                        className="dropdown-item noFilterHover form-group form-check ml-4 wa nohover mb-0 h-38"
                        key={key}
                      >
                        <input
                          type="checkbox"
                          className="form-check-input mt-2"
                          id="exampleCheck1"
                          onChange={() => handleLocations(item.value)}
                        />
                        <label className="form-check-label" for="exampleCheck1">
                          <small className="small-text">{item.label}</small>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="dropdown mb-4">
                <div className="dropdown">
                  <button
                    className="btn btn-block border text-left overlay-dropdown-input"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    data-display="static"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClickCapture={() => setAgeRangeIcon(!ageRangeIcon)}
                  >
                    <div className="d-flex justify-content-between">
                      <small className="small-text">Choose Country</small>
                      <BsChevronDown
                        style={{
                          transform: ageRangeIconRotate,
                          transition: "all 0.3s linear",
                        }}
                      />
                    </div>
                  </button>
                  <div
                    className="dropdown-menu dropdown-menu--animate custom border-0 shadow overlay-dropdown-container"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <p className="pl-2 mb-0 pb-2">
                      <small className="small-text">
                        Choose as many as applicable:
                      </small>
                    </p>
                    {getClinicalSiteCountries.map((item, key) => (
                      <div
                        className="dropdown-item noFilterHover form-group form-check ml-4 wa nohover mb-0 h-38"
                        key={key}
                      >
                        <input
                          type="checkbox"
                          className="form-check-input mt-2"
                          id="exampleCheck1"
                          onChange={() => handleAge(item.value)}
                        />
                        <label className="form-check-label" for="exampleCheck1">
                          <small className="small-text">{item.label}</small>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-between align-items-center border-0">
              <button
                type="button"
                className="btn btn_outline_danger overlay-btn"
                data-dismiss="modal"
              >
                CLEAR
              </button>
              <button
                type="button"
                className="btn btn-outline-primary overlay-btn"
              >
                SEARCH
              </button>
            </div>
          </div>
        </div>
      </div> */}
      <Footer />
    </>
  );
};

export default AdminDashboard;
